import * as React from "react";
import PropTypes from 'prop-types'

const AlertTriangleTransfermate = ({
    style = {},
    size = 64,
    height,
    width,
    svgRef,
    title,
    ...props
  }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={height || size}
    height={width || size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#F0C20A"
      fillRule="evenodd"
      d="m21.577 16.896-6.86-13.11c-.94-1.79-3.49-1.79-4.43 0l-6.87 13.11c-.87 1.66.34 3.66 2.21 3.66h13.74c1.88 0 3.09-2 2.21-3.66m-2.21 1.66H5.627c-.38 0-.62-.4-.44-.73l6.87-13.11c.19-.36.7-.36.89 0l6.87 13.11c.17.33-.07.73-.44.73zm-5.87-5.75v-3.5c0-.27-.11-.52-.29-.71a1 1 0 0 0-.71-.29c-.27 0-.52.11-.71.29a1 1 0 0 0-.29.71v3.5c0 .27.11.52.29.71.19.19.44.29.71.29s.52-.11.71-.29.29-.44.29-.71m-1.56 2.17c.16-.11.36-.17.56-.17.27 0 .52.11.71.29.19.19.29.44.29.71 0 .2-.06.39-.17.56-.11.16-.27.29-.45.37s-.38.1-.58.06c-.19-.04-.37-.13-.51-.27a.94.94 0 0 1-.27-.51 1.014 1.014 0 0 1 .43-1.03z"
      clipRule="evenodd"
    ></path>
  </svg>
);

AlertTriangleTransfermate.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export { AlertTriangleTransfermate }
